(() => {
  // app/scripts/common/component/slider-component.js
  var customElementsName = "slider-component";
  !window.customElements.get(customElementsName) && window.customElements.define(
    customElementsName,
    class extends HTMLElement {
      connectedCallback() {
        let config = this.querySelector('script[type*="json"]');
        if (!config)
          return;
        this.config = JSON.parse(config.innerHTML);
        this.sliderContainer = this.querySelector(".js-slider");
        if (this.classList.contains("jsSliderDelay"))
          return;
        this.createSlider();
        this._handlePopupClosed = this.handlePopupClosed.bind(this);
        window.addEventListener("popup:closed", this._handlePopupClosed);
        this.addEventListener("click", (e) => {
          const popupToggle = e.target.closest("[data-slider-pause-popup]");
          if (popupToggle) {
            this.pauseForPopup(popupToggle);
          }
          if (e.target.closest(".js-pause-button")) {
            this.pauseSlider();
            this.querySelector(".js-play-button").classList.remove("is-hidden");
            this.querySelector(".js-pause-button").classList.add("is-hidden");
          } else if (e.target.closest(".js-play-button")) {
            this.playSlider();
            this.querySelector(".js-play-button").classList.add("is-hidden");
            this.querySelector(".js-pause-button").classList.remove("is-hidden");
          }
        });
      }
      disconnectedCallback() {
        window.removeEventListener("popup:closed", this._handlePopupClosed);
      }
      load(config = {}) {
        this.config = { ...this.config, ...config };
        this.createSlider();
      }
      isAutoplayRunning() {
        return !!this.slider?.autoplay && this.slider.autoplay.running !== false;
      }
      pauseForPopup(trigger) {
        const control = trigger.dataset.control || (trigger.dataset.id ? `#${trigger.dataset.id}` : "");
        if (!control || !this.slider?.autoplay)
          return;
        const popup = document.querySelector(`.popup-component[data-control="${control}"],${control}`);
        if (!popup)
          return;
        this.popupPauseId = popup.id;
        this.resumeAfterPopup = this.isAutoplayRunning();
        this.pauseSlider();
      }
      handlePopupClosed(e) {
        if (!this.popupPauseId || e.detail?.id !== this.popupPauseId)
          return;
        const shouldResume = this.resumeAfterPopup;
        this.popupPauseId = null;
        this.resumeAfterPopup = false;
        if (shouldResume) {
          this.playSlider();
        }
      }
      pauseSlider() {
        this.slider?.autoplay?.stop();
      }
      playSlider() {
        this.slider?.autoplay?.start();
      }
      createSlider() {
        if (this.slider || !this.sliderContainer.childElementCount)
          return;
        const sliderLibrary = this.config.slider_library || "swiper";
        this.classList.remove("jsSliderDelay");
        if (sliderLibrary === "swiper") {
          return this.createSwiperSlider();
        } else if (sliderLibrary === "slick") {
          return this.createSlickSlider();
        } else if (sliderLibrary === "tiny-slider") {
          return this.createTinySlider();
        } else {
          console.warn(`Slider library not supported: ${sliderLibrary}`);
          return null;
        }
      }
      createSwiperSlider() {
        if (!window.SwiperSlider) {
          setTimeout(() => this.load(), 50);
          return;
        }
        if (!this.sliderContainer.children[0]?.classList.contains("swiper-slide")) {
          [...this.sliderContainer.children].forEach((child) => {
            child.classList.add("swiper-slide");
          });
        }
        const { Swiper, Modules } = window.SwiperSlider;
        this.normalizeSpaceBetween();
        const swiperConfig = this.mapConfigToSwiper();
        this.slider = new Swiper(this, {
          init: false,
          ...swiperConfig,
          modules: Modules
        });
        this.slider.on("init", this.onInit.bind(this));
        this.slider.on("breakpoint", (e) => {
          this.classList.toggle("slider-enabled", e.enabled);
          this.toggleGridClasses(e.enabled);
          this.toggleSliderInitialized(e.enabled);
        });
        this.slider.init();
        if (this.slider.enabled !== void 0) {
          this.toggleGridClasses(this.slider.enabled);
          this.toggleSliderInitialized(this.slider.enabled);
        }
        return this.slider;
      }
      createSlickSlider() {
        if (!window.jQuery || !jQuery.fn.slick) {
          setTimeout(() => this.load(), 50);
          return;
        }
        const slickConfig = this.mapConfigToSlick();
        this.slider = jQuery(this.sliderContainer).slick(slickConfig);
        this.onInit();
        const mediaQueryList = {};
        const breakpoints = this.config.breakpoints;
        for (const bp in breakpoints) {
          if (bp === "0")
            continue;
          const query = window.matchMedia(`(min-width: ${bp}px)`);
          mediaQueryList[bp] = query;
          query.addEventListener("change", (e) => {
            const enabled = breakpoints[bp].enabled;
            this.toggleGridClasses(enabled);
            this.toggleSliderInitialized(enabled);
          });
        }
        this.mediaQueryList = mediaQueryList;
        this.checkSlickBreakpoint();
        return this.slider;
      }
      checkSlickBreakpoint() {
        let currentBreakpoint = "0";
        const breakpoints = Object.keys(this.config.breakpoints).sort((a, b) => parseInt(a) - parseInt(b));
        for (const bp of breakpoints) {
          if (window.innerWidth >= parseInt(bp)) {
            currentBreakpoint = bp;
          } else {
            break;
          }
        }
        const enabled = this.config.breakpoints[currentBreakpoint]?.enabled || false;
        this.toggleGridClasses(enabled);
        this.toggleSliderInitialized(enabled);
      }
      createTinySlider() {
        if (!window.tns) {
          setTimeout(() => this.load(), 50);
          return;
        }
        const tnsConfig = this.mapConfigToTinySlider();
        this.slider = tns(tnsConfig);
        this.onInit();
        const mediaQueryList = {};
        const breakpoints = this.config.breakpoints;
        for (const bp in breakpoints) {
          if (bp === "0")
            continue;
          const query = window.matchMedia(`(min-width: ${bp}px)`);
          mediaQueryList[bp] = query;
          query.addEventListener("change", (e) => {
            const enabled = breakpoints[bp].enabled;
            this.toggleGridClasses(enabled);
            this.toggleSliderInitialized(enabled);
          });
        }
        this.mediaQueryList = mediaQueryList;
        this.checkTinySliderBreakpoint();
        return this.slider;
      }
      checkTinySliderBreakpoint() {
        let currentBreakpoint = "0";
        const breakpoints = Object.keys(this.config.breakpoints).sort((a, b) => parseInt(a) - parseInt(b));
        for (const bp of breakpoints) {
          if (window.innerWidth >= parseInt(bp)) {
            currentBreakpoint = bp;
          } else {
            break;
          }
        }
        const enabled = this.config.breakpoints[currentBreakpoint]?.enabled || false;
        this.toggleGridClasses(enabled);
        this.toggleSliderInitialized(enabled);
      }
      // Toggle slider-initialized class based on enabled state
      toggleSliderInitialized(enabled) {
        const sliderContainer = this.sliderContainer;
        if (!sliderContainer)
          return;
        if (enabled) {
          sliderContainer.classList.add("slider-initialized");
        } else {
          sliderContainer.classList.remove("slider-initialized");
        }
      }
      // Toggle grid classes based on slider enabled state
      toggleGridClasses(enabled) {
        if (!this.config.grid_class)
          return;
        const gridClasses = this.config.grid_class.split(" ").filter(Boolean);
        const sliderContainer = this.sliderContainer;
        if (!sliderContainer)
          return;
        if (enabled) {
          gridClasses.forEach((className) => {
            sliderContainer.classList.remove(className);
          });
        } else {
          gridClasses.forEach((className) => {
            sliderContainer.classList.add(className);
          });
        }
      }
      // Function to normalize space_between values
      normalizeSpaceBetween() {
        this.config.space_between && (this.config.space_between = +this.config.space_between.toString().replace(/[^\d.,]/g, ""));
        for (let i in this.config.breakpoints) {
          let spaceBetween = this.config.breakpoints[i]?.space_between || 0;
          this.config.breakpoints[i].space_between = +spaceBetween.toString().replace(/[^\d.,]/g, "");
        }
      }
      // Map common config to Swiper config
      mapConfigToSwiper() {
        const swiperConfig = { ...this.config };
        swiperConfig.slidesPerView = swiperConfig.slides_per_view;
        swiperConfig.spaceBetween = swiperConfig.space_between;
        swiperConfig.autoHeight = swiperConfig.auto_height;
        if (swiperConfig.navigation) {
          swiperConfig.navigation.prevEl = swiperConfig.navigation.prev_el;
          swiperConfig.navigation.nextEl = swiperConfig.navigation.next_el;
        }
        if (swiperConfig.autoplay) {
          swiperConfig.autoplay.disableOnInteraction = swiperConfig.autoplay.disable_on_interaction;
        }
        if (swiperConfig.scrollbar) {
          swiperConfig.scrollbar.snapOnRelease = swiperConfig.scrollbar.snap_on_release;
        }
        for (const breakpoint in swiperConfig.breakpoints) {
          const bp = swiperConfig.breakpoints[breakpoint];
          bp.slidesPerView = bp.slides_per_view;
          bp.spaceBetween = bp.space_between;
        }
        return swiperConfig;
      }
      // Map common config to Slick config
      mapConfigToSlick() {
        const { loop, slides_per_view, space_between, navigation, pagination, autoplay, breakpoints } = this.config;
        const responsive = [];
        for (const breakpoint in breakpoints) {
          if (breakpoint === "0")
            continue;
          responsive.push({
            breakpoint: parseInt(breakpoint),
            settings: {
              slidesToShow: breakpoints[breakpoint].slides_per_view,
              slidesToScroll: 1,
              infinite: loop
            }
          });
        }
        return {
          infinite: loop,
          slidesToShow: slides_per_view,
          slidesToScroll: 1,
          arrows: navigation?.enabled || false,
          prevArrow: navigation?.enabled ? this.querySelector(".js-prev-button") : null,
          nextArrow: navigation?.enabled ? this.querySelector(".js-next-button") : null,
          dots: pagination?.enabled || false,
          autoplay: autoplay ? true : false,
          autoplaySpeed: autoplay?.delay || 3e3,
          responsive
        };
      }
      // Map common config to TinySlider config
      mapConfigToTinySlider() {
        const { loop, slides_per_view, space_between, navigation, pagination, autoplay, breakpoints } = this.config;
        const responsive = {};
        for (const breakpoint in breakpoints) {
          responsive[breakpoint] = {
            items: breakpoints[breakpoint].slides_per_view,
            gutter: breakpoints[breakpoint].space_between
          };
        }
        return {
          container: this.sliderContainer,
          items: slides_per_view,
          loop,
          gutter: space_between,
          nav: pagination?.enabled || false,
          controls: navigation?.enabled || false,
          prevButton: navigation?.enabled ? this.querySelector(".js-prev-button") : null,
          nextButton: navigation?.enabled ? this.querySelector(".js-next-button") : null,
          autoplay: autoplay ? true : false,
          autoplayTimeout: autoplay?.delay || 3e3,
          responsive
        };
      }
      onChange(e) {
        const slideIndex = this.querySelector(".jsSlideIndex");
        if (!slideIndex)
          return;
        const index = typeof e === "object" ? e.index : e;
        slideIndex.innerHTML = index + 1;
      }
      onInit() {
        this.removeAttribute("slider-wait");
        const sliderContainer = this.sliderContainer;
        if (sliderContainer) {
          sliderContainer.classList.add("flex-nowrap");
        }
        if (this.slider?.enabled !== void 0) {
          this.toggleGridClasses(this.slider.enabled);
          this.toggleSliderInitialized(this.slider.enabled);
        } else if (this.config.breakpoints) {
          if (this.config.slider_library === "slick") {
            this.checkSlickBreakpoint();
          } else if (this.config.slider_library === "tiny-slider") {
            this.checkTinySliderBreakpoint();
          }
        }
        window.dispatchEvent(new Event("lazy:update"));
      }
      getSlide() {
        return this.slider;
      }
      unLoad() {
        const sliderLibrary = this.config.slider_library || "swiper";
        if (this.mediaQueryList) {
          for (const bp in this.mediaQueryList) {
            this.mediaQueryList[bp].removeEventListener("change");
          }
          this.mediaQueryList = null;
        }
        if (sliderLibrary === "swiper") {
          if (this.slider && this.slider.destroy) {
            this.slider.destroy();
          }
        } else if (sliderLibrary === "slick") {
          if (this.slider && this.slider.slick) {
            this.slider.slick("unslick");
          }
        } else if (sliderLibrary === "tiny-slider") {
          if (this.slider && this.slider.destroy) {
            this.slider.destroy();
          }
        }
        this.slider = null;
      }
      goTo(index) {
        const sliderLibrary = this.config.slider_library || "swiper";
        if (sliderLibrary === "swiper") {
          if (index == "next")
            this.slider?.slideNext();
          else if (index == "prev")
            this.slider?.slidePrev();
          else
            this.slider?.slideTo(index);
        } else if (sliderLibrary === "slick") {
          if (index == "next")
            this.slider.slick("slickNext");
          else if (index == "prev")
            this.slider.slick("slickPrev");
          else
            this.slider.slick("slickGoTo", index);
        } else if (sliderLibrary === "tiny-slider") {
          if (index == "next")
            this.slider.goTo("next");
          else if (index == "prev")
            this.slider.goTo("prev");
          else
            this.slider.goTo(index);
        }
      }
    }
  );
})();
